<template>
<div class="chapter">
<div class="inner_page">
<p class="toc2"><span><b>CONTENTS</b></span></p>
<p class="toc2"><a href="#/Book3/1cover#cover">BOY’S LIFE</a></p>
<p class="toc1"><a href="#/Book3/4start#chap1">Prologue</a></p>
<p class="toc1"><a href="#/Book3/6chap2#chap2">One: The Shades of Spring</a></p>
<p class="toc1"><a href="#/Book3/7chap3#chap3">1. Before the Sun</a></p>
<p class="toc1"><a href="#/Book3/8chap4#chap4">2. Down in the Dark</a></p>
<p class="toc1"><a href="#/Book3/9chap5#chap5">3. The Invader </a></p>
<p class="toc1"><a href="#/Book3/10chap6#chap6">4. Wasps at Easter</a></p>
<p class="toc1"><a href="#/Book3/11chap7#chap7">5. The Death of a Bike</a></p>
<p class="toc1"><a href="#/Book3/12chap8#chap8">6. Old Moses Comes to Call</a></p>
<p class="toc1"><a href="#/Book3/13chap9#chap9">7. A Summons From the Lady</a></p>
<p class="toc1"><a href="#/Book3/14chap10#chap10">Two: A Summer of Devils and Angels</a></p>
<p class="toc1"><a href="#/Book3/15chap11#chap11">1. Last Day of School</a></p>
<p class="toc1"><a href="#/Book3/16chap12#chap12">2. Barbershop Talk</a></p>
<p class="toc1"><a href="#/Book3/17chap13#chap13">3. A Boy And a Ball</a></p>
<p class="toc1"><a href="#/Book3/18chap14#chap14">4. I Get Around</a></p>
<p class="toc1"><a href="#/Book3/19chap15#chap15">5. Welcome, Lucifer</a></p>
<p class="toc1"><a href="#/Book3/20chap16#chap16">6. Nemo’s Mother &amp; A Week With the Jaybird</a></p>
<p class="toc1"><a href="#/Book3/21chap17#chap17">7. My Camping Trip</a></p>
<p class="toc1"><a href="#/Book3/22chap18#chap18">8. Chile Willow</a></p>
<p class="toc1"><a href="#/Book3/23chap19#chap19">9. Summer Winds Up</a></p>
<p class="toc1"><a href="#/Book3/24chap20#chap20">Three: Burning Autumn</a></p>
<p class="toc1"><a href="#/Book3/25chap21#chap21">1. Green-Feathered Hat</a></p>
<p class="toc1"><a href="#/Book3/26chap22#chap22">2. The Magic Box</a></p>
<p class="toc1"><a href="#/Book3/27chap23#chap23">3. Dinner With Vernon</a></p>
<p class="toc1"><a href="#/Book3/28chap24#chap24">4. The Wrath of Five Thunders</a></p>
<p class="toc1"><a href="#/Book3/29chap25#chap25">5. Case #3432</a></p>
<p class="toc1"><a href="#/Book3/30chap26#chap26">6. Dead Man Driving</a></p>
<p class="toc1"><a href="#/Book3/31chap27#chap27">7. High Noon In Zephyr</a></p>
<p class="toc1"><a href="#/Book3/32chap28#chap28">8. From the Lost World</a></p>
<p class="toc1"><a href="#/Book3/33chap29#chap29">Four: Winter’s Cold Truth</a></p>
<p class="toc1"><a href="#/Book3/34chap30#chap30">1. A Solitary Traveler</a></p>
<p class="toc1"><a href="#/Book3/35chap31#chap31">2. Faith</a></p>
<p class="toc1"><a href="#/Book3/36chap32#chap32">3. Snippets Of The Quilt</a></p>
<p class="toc1"><a href="#/Book3/37chap33#chap33">4. Mr. Moultry’s Castle</a></p>
<p class="toc1"><a href="#/Book3/38chap34#chap34">5. Sixteen Drops Of Blood</a></p>
<p class="toc1"><a href="#/Book3/39chap35#chap35">6. The Stranger Among Us</a></p>
<p class="toc1"><a href="#/Book3/40chap36#chap36">Five: Zephyr as It is</a></p>
<p class="toc1"><a href="#/Book3/41acknowledgments#acknowledgments">Acknowledgements</a></p>
<p class="toc2"><a href="#/Book1/1cover#cover">MYSTERY WALK</a></p>
<p class="toc1"><a href="#/Book1/5chap1#chap1">Prologue</a></p>
<p class="toc1"><a href="#/Book1/6chap2#chap2">One: Hawthorne</a></p>
<p class="toc1"><a href="#/Book1/7chap3#chap3">1</a></p>
<p class="toc1"><a href="#/Book1/8chap4#chap4">2</a></p>
<p class="toc1"><a href="#/Book1/9chap5#chap5">3</a></p>
<p class="toc1"><a href="#/Book1/10chap6#chap6">4</a></p>
<p class="toc1"><a href="#/Book1/11chap7#chap7">5</a></p>
<p class="toc1"><a href="#/Book1/12chap8#chap8">6</a></p>
<p class="toc1"><a href="#/Book1/13chap9#chap9">Two: The Coal Pile</a></p>
<p class="toc1"><a href="#/Book1/14chap10#chap10">7</a></p>
<p class="toc1"><a href="#/Book1/15chap11#chap11">8</a></p>
<p class="toc1"><a href="#/Book1/16chap12#chap12">9</a></p>
<p class="toc1"><a href="#/Book1/17chap13#chap13">10</a></p>
<p class="toc1"><a href="#/Book1/18chap14#chap14">Three: Tent Show</a></p>
<p class="toc1"><a href="#/Book1/19chap15#chap15">11</a></p>
<p class="toc1"><a href="#/Book1/20chap16#chap16">12</a></p>
<p class="toc1"><a href="#/Book1/21chap17#chap17">13</a></p>
<p class="toc1"><a href="#/Book1/22chap18#chap18">14</a></p>
<p class="toc1"><a href="#/Book1/23chap19#chap19">15</a></p>
<p class="toc1"><a href="#/Book1/24chap20#chap20">16</a></p>
<p class="toc1"><a href="#/Book1/25chap21#chap21">Four: Potter’s Clay</a></p>
<p class="toc1"><a href="#/Book1/26chap22#chap22">17</a></p>
<p class="toc1"><a href="#/Book1/27chap23#chap23">18</a></p>
<p class="toc1"><a href="#/Book1/28chap24#chap24">19</a></p>
<p class="toc1"><a href="#/Book1/29chap25#chap25">Five: Black Aura</a></p>
<p class="toc1"><a href="#/Book1/30chap26#chap26">20</a></p>
<p class="toc1"><a href="#/Book1/31chap27#chap27">21</a></p>
<p class="toc1"><a href="#/Book1/32chap28#chap28">22</a></p>
<p class="toc1"><a href="#/Book1/33chap29#chap29">23</a></p>
<p class="toc1"><a href="#/Book1/34chap30#chap30">Six: May Night</a></p>
<p class="toc1"><a href="#/Book1/35chap31#chap31">24</a></p>
<p class="toc1"><a href="#/Book1/36chap32#chap32">25</a></p>
<p class="toc1"><a href="#/Book1/37chap33#chap33">26</a></p>
<p class="toc1"><a href="#/Book1/38chap34#chap34">27</a></p>
<p class="toc1"><a href="#/Book1/39chap35#chap35">28</a></p>
<p class="toc1"><a href="#/Book1/40chap36#chap36">29</a></p>
<p class="toc1"><a href="#/Book1/41chap37#chap37">Seven: Ghost Show</a></p>
<p class="toc1"><a href="#/Book1/42chap38#chap38">30</a></p>
<p class="toc1"><a href="#/Book1/43chap39#chap39">31</a></p>
<p class="toc1"><a href="#/Book1/44chap40#chap40">32</a></p>
<p class="toc1"><a href="#/Book1/45chap41#chap41">33</a></p>
<p class="toc1"><a href="#/Book1/46chap42#chap42">34</a></p>
<p class="toc1"><a href="#/Book1/47chap43">Eight: Serpent and Octopus</a></p>
<p class="toc1"><a href="#/Book1/48chap44#chap44">35</a></p>
<p class="toc1"><a href="#/Book1/49chap45#chap45">36</a></p>
<p class="toc1"><a href="#/Book1/50chap46#chap46">37</a></p>
<p class="toc1"><a href="#/Book1/51chap47#chap47">38</a></p>
<p class="toc1"><a href="#/Book1/52chap48#chap48">39</a></p>
<p class="toc1"><a href="#/Book1/53chap49#chap49">40</a></p>
<p class="toc1"><a href="#/Book1/54chap50#chap50">41</a></p>
<p class="toc1"><a href="#/Book1/55chap51#chap51">Nine: Revelations</a></p>
<p class="toc1"><a href="#/Book1/56chap52#chap52">42</a></p>
<p class="toc1"><a href="#/Book1/57chap53#chap53">43</a></p>
<p class="toc1"><a href="#/Book1/58chap54#chap54">Ten: Krepsin</a></p>
<p class="toc1"><a href="#/Book1/59chap55#chap55">44</a></p>
<p class="toc1"><a href="#/Book1/60chap56#chap56">45</a></p>
<p class="toc1"><a href="#/Book1/61chap57#chap57">46</a></p>
<p class="toc1"><a href="#/Book1/62chap58#chap58">47</a></p>
<p class="toc1"><a href="#/Book1/63chap59#chap59">48</a></p>
<p class="toc1"><a href="#/Book1/64chap60#chap60">49</a></p>
<p class="toc1"><a href="#/Book1/65chap61#chap61">Eleven: The Test</a></p>
<p class="toc1"><a href="#/Book1/66chap62#chap62">50</a></p>
<p class="toc1"><a href="#/Book1/67chap63#chap63">51</a></p>
<p class="toc1"><a href="#/Book1/68chap64#chap64">52</a></p>
<p class="toc1"><a href="#/Book1/69chap65#chap65">53</a></p>
<p class="toc1"><a href="#/Book1/70chap66#chap66">54</a></p>
<p class="toc1"><a href="#/Book1/71chap67#chap67">55</a></p>
<p class="toc1"><a href="#/Book1/72chap68#chap68">56</a></p>
<p class="toc1"><a href="#/Book1/73chap69#chap69">57</a></p>
<p class="toc1"><a href="#/Book1/74chap70#chap70">58</a></p>
<p class="toc1"><a href="#/Book1/75chap71#chap71">Twelve: Inferno</a></p>
<p class="toc1"><a href="#/Book1/76chap72#chap72">59</a></p>
<p class="toc1"><a href="#/Book1/77chap73#chap73">60</a></p>
<p class="toc1"><a href="#/Book1/78chap74#chap74">61</a></p>
<p class="toc1"><a href="#/Book1/79chap75#chap75">62</a></p>
<p class="toc1"><a href="#/Book1/80chap76#chap76">63</a></p>
<p class="toc1"><a href="#/Book1/81chap77#chap77">Thirteen: Home</a></p>
<p class="toc1"><a href="#/Book1/82chap78#chap78">64</a></p>
<p class="toc2"><a href="#/Book4/1cover#cover">GONE SOUTH</a></p>
<p class="toc1"><a href="#/Book4/5start#chap1">FOREWORD</a></p>
<p class="toc1"><a href="#/Book4/6chap2#chap2">1. THE GOOD SON</a></p>
<p class="toc1"><a href="#/Book4/7chap3#chap3">2. TICKING</a></p>
<p class="toc1"><a href="#/Book4/8chap4#chap4">3. MARK OF CAIN</a></p>
<p class="toc1"><a href="#/Book4/9chap5#chap5">4. THE HAND OF CLINT</a></p>
<p class="toc1"><a href="#/Book4/10chap6#chap6">5. A WAYS TO GO</a></p>
<p class="toc1"><a href="#/Book4/11chap7#chap7">6. MEET THE PELVIS</a></p>
<p class="toc1"><a href="#/Book4/12chap8#chap8">7. BIG OL’ FROG</a></p>
<p class="toc1"><a href="#/Book4/13chap9#chap9">8. MYSTERIOUS WAYS</a></p>
<p class="toc1"><a href="#/Book4/14chap10#chap10">9. TIME THE THIEF</a></p>
<p class="toc1"><a href="#/Book4/15chap11#chap11">10. LINE OF FIRE</a></p>
<p class="toc1"><a href="#/Book4/16chap12#chap12">11. TRAVELING BY NIGHT</a></p>
<p class="toc1"><a href="#/Book4/17chap13#chap13">12. JUPITER</a></p>
<p class="toc1"><a href="#/Book4/18chap14#chap14">13. SATAN’S PARADISE</a></p>
<p class="toc1"><a href="#/Book4/19chap15#chap15">14. THE SMALL SKULLS</a></p>
<p class="toc1"><a href="#/Book4/20chap16#chap16">15. THE TRUTH</a></p>
<p class="toc1"><a href="#/Book4/21chap17#chap17">16. BLACK AGAINST YELLOW</a></p>
<p class="toc1"><a href="#/Book4/22chap18#chap18">17. CORRIDORS AND WALLS</a></p>
<p class="toc1"><a href="#/Book4/23chap19#chap19">18. THE MOST DANGEROUS PLACE</a></p>
<p class="toc1"><a href="#/Book4/24chap20#chap20">19. HOME SWEET HELLHOLE</a></p>
<p class="toc1"><a href="#/Book4/25chap21#chap21">20. THE KING BLED CRIMSON</a></p>
<p class="toc1"><a href="#/Book4/26chap22#chap22">21. SILENT SHADOW</a></p>
<p class="toc1"><a href="#/Book4/27chap23#chap23">22. THE SOUND OF SCALES</a></p>
<p class="toc1"><a href="#/Book4/28chap24#chap24">23. CROSSBONES</a></p>
<p class="toc1"><a href="#/Book4/29chap25#chap25">24. ELEPHANTS AND TIGERS</a></p>
<p class="toc1"><a href="#/Book4/30chap26#chap26">25. REPTILIAN</a></p>
<p class="toc1"><a href="#/Book4/31chap27#chap27">26. TO THE EDGE</a></p>
<p class="toc1"><a href="#/Book4/32chap28#chap28">27. TOO DAMN HOT</a></p>
<p class="toc1"><a href="#/Book4/33chap29#chap29">28. AVRIETTA’S ISLAND</a></p>
<p class="toc1"><a href="#/Book4/34chap30#chap30">29. THE BRIGHT GIRL</a></p>
<p class="toc2"><a href="#/Book2/1cover#cover">USHER’S PASSING</a></p>
<p class="toc1"><a href="#/Book2/6chap1#chap1">Prologue</a></p>
<p class="toc1"><a href="#/Book2/7chap2#chap2">I</a></p>
<p class="toc1"><a href="#/Book2/8chap3#chap3">II</a></p>
<p class="toc1"><a href="#/Book2/9chap4#chap4">III</a></p>
<p class="toc1"><a href="#/Book2/10chap5#chap5">One: Usherland</a></p>
<p class="toc1"><a href="#/Book2/11chap6#chap6">1</a></p>
<p class="toc1"><a href="#/Book2/12chap7#chap7">2</a></p>
<p class="toc1"><a href="#/Book2/13chap8#chap8">3</a></p>
<p class="toc1"><a href="#/Book2/14chap9#chap9">Two: The Mountain Boy</a></p>
<p class="toc1"><a href="#/Book2/15chap10#chap10">4</a></p>
<p class="toc1"><a href="#/Book2/16chap11#chap11">5</a></p>
<p class="toc1"><a href="#/Book2/17chap12#chap12">6</a></p>
<p class="toc1"><a href="#/Book2/18chap13#chap13">7</a></p>
<p class="toc1"><a href="#/Book2/19chap14#chap14">8</a></p>
<p class="toc1"><a href="#/Book2/20chap15#chap15">9</a></p>
<p class="toc1"><a href="#/Book2/21chap16#chap16">10</a></p>
<p class="toc1"><a href="#/Book2/22chap17#chap17">11</a></p>
<p class="toc1"><a href="#/Book2/23chap19#chap19">Three: Raven</a></p>
<p class="toc1"><a href="#/Book2/24chap18#chap18">12</a></p>
<p class="toc1"><a href="#/Book2/25chap20#chap20">13</a></p>
<p class="toc1"><a href="#/Book2/26chap21#chap21">14</a></p>
<p class="toc1"><a href="#/Book2/27chap22#chap22">15</a></p>
<p class="toc1"><a href="#/Book2/28chap23#chap23">16</a></p>
<p class="toc1"><a href="#/Book2/29chap24#chap24">17</a></p>
<p class="toc1"><a href="#/Book2/30chap25#chap25">18</a></p>
<p class="toc1"><a href="#/Book2/31chap26">Four: The Mountain King</a></p>
<p class="toc1"><a href="#/Book2/32chap27#chap27">19</a></p>
<p class="toc1"><a href="#/Book2/33chap28#chap28">20</a></p>
<p class="toc1"><a href="#/Book2/34chap29#chap29">21</a></p>
<p class="toc1"><a href="#/Book2/35chap30#chap30">22</a></p>
<p class="toc1"><a href="#/Book2/36chap31#chap31">23</a></p>
<p class="toc1"><a href="#/Book2/37chap32#chap32">24</a></p>
<p class="toc1"><a href="#/Book2/38chap33#chap33">25</a></p>
<p class="toc1"><a href="#/Book2/39chap34">Five: Time Will Tell the Tale</a></p>
<p class="toc1"><a href="#/Book2/40chap35#chap35">26</a></p>
<p class="toc1"><a href="#/Book2/41chap36#chap36">27</a></p>
<p class="toc1"><a href="#/Book2/42chap37#chap37">28</a></p>
<p class="toc1"><a href="#/Book2/43chap38#chap38">29</a></p>
<p class="toc1"><a href="#/Book2/44chap39#chap39">30</a></p>
<p class="toc1"><a href="#/Book2/45chap40#chap40">31</a></p>
<p class="toc1"><a href="#/Book2/46chap41#chap41">32</a></p>
<p class="toc1"><a href="#/Book2/47chap42">Six: Valley of the Shadow</a></p>
<p class="toc1"><a href="#/Book2/48chap43#chap43">33</a></p>
<p class="toc1"><a href="#/Book2/49chap44#chap44">34</a></p>
<p class="toc1"><a href="#/Book2/50chap45#chap45">35</a></p>
<p class="toc1"><a href="#/Book2/51chap46#chap46">36</a></p>
<p class="toc1"><a href="#/Book2/52chap47#chap47">37</a></p>
<p class="toc1"><a href="#/Book2/53chap48#chap48">Seven: The Lodge</a></p>
<p class="toc1"><a href="#/Book2/54chap49#chap49">38</a></p>
<p class="toc1"><a href="#/Book2/55chap50#chap50">39</a></p>
<p class="toc1"><a href="#/Book2/56chap51#chap51">40</a></p>
<p class="toc1"><a href="#/Book2/57chap52#chap52">41</a></p>
<p class="toc1"><a href="#/Book2/58chap53#chap53">42</a></p>
<p class="toc1"><a href="#/Book2/59chap54#chap54">43</a></p>
<p class="toc1"><a href="#/Book2/60chap55#chap55">44</a></p>
<p class="toc1"><a href="#/Book2/61chap56#chap56">Eight: The Decision</a></p>
<p class="toc1"><a href="#/Book2/62chap57#chap57">45</a></p>
<p class="toc1"><a href="#/Book2/63chap58#chap58">46</a></p>
<p class="toc2"><span href="#/Comon/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?23e3f271